import { queryKeys } from '../../lib/queryKeys';

/**
 * Re-exported from `lib/queryKeys.ts`, where the keys always were.
 *
 * This module used to declare its own, with a header explaining it was written
 * "while apps/web/src/lib/queryKeys.ts was owned by another agent" and noting
 * that its keys were value-identical to the shared ones. They were. Folded
 * back, as that header asked.
 */
export const activityQueryKeys = {
  workspace: queryKeys.activity,
  request: queryKeys.requestActivity,
} as const;
